<!-- Copyright (c) 2019-2024 Cigent Technology Inc. All Rights Reserved. -->
<div class="main-content" appLifecycleTracker trackerName="manage-policies">
    <div class="row">
        <div class="col1">
            <app-policy-list
                    [policies]="policies"
                    [loadedPolicy]="loadedPolicy"
                    [isDirty]="isDirty"
                    [selectedOrgId]="selectedOrgId"
                    (policyLoad)="loadPolicy($event)"
                    (policyRename)="renamePolicy($event)"
                    (policyDelete)="deletePolicy($event)"
                    (priorityChange)="changePriorities($event)"
                    (policyAdd)="addPolicy($event)"
                    (policyClone)="clonePolicy($event)"
                    (policyCanceled)="onEditorCanceled()">
            </app-policy-list>
        </div>
        <div class="col2" *ngIf="d3ePolicy">
            <ng-container *ngIf="tierStatus$ | async as status">
                <app-policy-editor
                    [d3ePolicy]="d3ePolicy"
                    [d3ePolicyId]="loadedPolicy"
                    [d3ePolicyName]="d3ePolicyName"
                    [devices]="devices"
                    [isDirty]="isDirty"
                    [policyEnabled]="d3ePolicyEnabled"
                    [haveDDTier]="status.dd"
                    [haveBitLockerTier]="status.bitLocker"
                    [haveFDETier]="status.agent && status.fde"
                    [havePBATier]="status.agent && status.pba"
                    [overrideLocalPolicy]="overrideLocalPolicy"
                    [allowAlwaysOn]="allowAlwaysOn"
                    [clientPolicy]="clientPolicy"
                    [clientPolicyDefaults]="clientPolicyDefaults"
                    [policyPageConfig]="policyPageConfig"
                    (overrideLocalPolicyChanged)="onOverrideLocalPolicyChanged($event)"
                    (allowAlwaysOnChanged)="allowAlwaysOnChanged($event)"
                    (policyCanceled)="onEditorCanceled()"
                    (policySaved)="onEditorSaved()"
                    (loadDeviceSettings)="onLoadDeviceSettings($event)"
                    (policyIsDirty)="onPolicyIsDirty($event)"
                    [show_environment_variables]="show_environment_variables"
                    [show_force_policy_checkbox]="show_force_policy_checkbox"
                    [selectedOrgId]="selectedOrgId"
                    [subKeyUUIDs]="sub_key_uuids"
                    [enableDataDeception]="adminSettings?.enable_data_deception"
                    [enableSubscriptionKey]="enableSubscriptionKey">
                </app-policy-editor>
            </ng-container>
        </div>
    </div>
</div>
